export const changeDistrictNameReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_DISTRICT_NAME":
      return action.payload.districtName;
    default:
      return state;
  }
};
